import { BUSINESS_ROLE_GROUPS } from '@/components/security/AppRoles';
import { EditUser, InviteUser, ViewUser } from '../pages';
import { ErrorPage } from '@/pages/Layout/pages';
import { RouteObject } from 'react-router-dom';
import { RoleRestriction } from '../enums';
import { Authorize } from '@/components';
import Users from '../Users';

const UsersRoutes: RouteObject[] = [
  {
    path: 'users',
    element: (
      <Authorize
        permission={BUSINESS_ROLE_GROUPS.withoutDispatcher}
        fallback={<ErrorPage code={403} />}
      >
        <Users />
      </Authorize>
    ),
  },
  {
    path: 'users/invite/operator',
    element: (
      <Authorize
        permission={BUSINESS_ROLE_GROUPS.management}
        fallback={<ErrorPage code={403} />}
      >
        <InviteUser
          lockedUserType={RoleRestriction.OPERATOR}
          pageTitle='Invitar Operador Soydelivery'
        />
      </Authorize>
    ),
  },
  {
    path: 'users/invite/commerce',
    element: (
      <Authorize
        permission={BUSINESS_ROLE_GROUPS.management}
        fallback={<ErrorPage code={403} />}
      >
        <InviteUser
          lockedUserType={RoleRestriction.COMMERCE}
          pageTitle='Invitar Comercio'
        />
      </Authorize>
    ),
  },
  {
    path: 'users/invite/external-operator',
    element: (
      <Authorize
        permission={BUSINESS_ROLE_GROUPS.management}
        fallback={<ErrorPage code={403} />}
      >
        <InviteUser
          lockedUserType={RoleRestriction.EXTERNAL_OPERATOR}
          pageTitle='Invitar Operador Externo'
        />
      </Authorize>
    ),
  },
  {
    path: 'users/:id/edit',
    element: (
      <Authorize
        permission={BUSINESS_ROLE_GROUPS.management}
        fallback={<ErrorPage code={403} />}
      >
        <EditUser />
      </Authorize>
    ),
  },
  {
    path: 'users/:id',
    element: (
      <Authorize
        permission={BUSINESS_ROLE_GROUPS.withoutDispatcher}
        fallback={<ErrorPage code={403} />}
      >
        <ViewUser />
      </Authorize>
    ),
  },
];

export default UsersRoutes;
